import CartFunnelListPage from "../../components/Pages/CartFunnel/List/List";

const CartFunnels = () => {
  return (
    <div>
      <CartFunnelListPage />
    </div>
  );
};

export default CartFunnels;
